export const IconRemoveCross: {
  name: 'icon_remove_cross-89006d599d86'
} = {
  name: 'icon_remove_cross-89006d599d86'
}
